<div #input class="input" [innerHtml]="value | default: placeholder" (paste)="_handlePaste($event)"
    (input)="_handleValueChange($event)" (mousedown)="_handleClick($event)" (focus)="_handleFocus($event)"
    (blur)="_handleBlur()" (keydown)="_handleKeydown($event)" contenteditable="true"></div>